export function implicitPolicyToPolicy(implicit) {
    return {
        Method: implicit[3],
        Role: implicit[0],
        Path: implicit[2],
        Domain: implicit[1]
    };
}